'use client';

import { Avatar } from '@onyx/ui/components/colleague/avatar';
import { Icon } from '@onyx/ui/components/colleague/icon';

import styles from './header-info-badge.module.css';

type HeaderInfoBadgeProps = {
  storeId?: string;
  label?: string;
  image?: string;
  onClick?: () => void;
};

const AvatarHolder = ({
  label,
  image,
}: Omit<HeaderInfoBadgeProps, 'storeId'>) => {
  if (image) {
    // eslint-disable-next-line @next/next/no-img-element -- avatar src is an arbitrary remote user photo (Azure AD / MS Graph); next/image would require host allow-listing via images.remotePatterns
    return <img src={image} alt={label} className={styles.avatarPlaceholder} />;
  }

  if (label) {
    return <Avatar label={label} color="informative" variant="secondary" />;
  }

  return (
    <div className={styles.avatarPlaceholder}>
      <Icon name="AccountCircle" size={20} />
    </div>
  );
};

export const HeaderInfoBadge = ({
  storeId,
  label,
  image,
  onClick,
}: HeaderInfoBadgeProps) => {
  return (
    <button
      type="button"
      className={styles.headerInfoContainer}
      onClick={onClick}
    >
      <Icon name="Business" size={18} />
      {storeId ? <span className={styles.label}>{storeId}</span> : null}
      <AvatarHolder label={label} image={image} />
    </button>
  );
};
